import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { View } from 'foundations-components/components/View';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { List } from 'foundations-components/transitional/components/List';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TAGS_TO_DISPLAY = 4;
const HubspotPlaylistTags = ({
  playlist
}) => {
  const tags = [...(playlist.subCategories || []), ...(playlist.hsSoftwareFilters || [])];
  const moreTags = tags.slice(TAGS_TO_DISPLAY, tags.length);
  const getTagType = tag =>
  // @ts-expect-error includes is too restrictive
  playlist !== null && playlist !== void 0 && playlist.subCategories.includes(tag) ? 'cat' : 'tools';
  return /*#__PURE__*/_jsx(_Fragment, {
    children: tags.length > 0 && /*#__PURE__*/_jsxs(View, {
      as: "div",
      marginBlock: "500",
      children: [/*#__PURE__*/_jsx(List, {
        inline: true,
        children: tags.slice(0, TAGS_TO_DISPLAY).map(tag => {
          const tagType = getTagType(tag.toString());
          const tagString = tag.toString();
          return /*#__PURE__*/_jsx(RouterLink, {
            to: `/results?${tagType}=${tagString}`,
            children: /*#__PURE__*/_jsx(Badge, {
              use: "pantera",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `learningCenter.topFilters.${tagType}.${tagString}`
              })
            })
          }, tagString);
        })
      }), moreTags.length > 0 && /*#__PURE__*/_jsx(Tooltip, {
        title: moreTags.map(tag => I18n.text(`learningCenter.topFilters.${getTagType(tag.toString())}.${tag.toString()}`)).join(', '),
        children: /*#__PURE__*/_jsxs(View, {
          cursor: "default",
          marginInlineStart: "200",
          children: ["+", moreTags.length]
        })
      })]
    })
  });
};
export default HubspotPlaylistTags;